import { CODIGO_SEM_DISPOSITIVO, HEADER_DISPOSITIVO } from '@projetive-op/domain'

/**
 * Token do dispositivo (ADR 0010): identifica "este tablet é o do posto X".
 * Vive no localStorage do aparelho e vai em todo request no header
 * `x-dispositivo`. Nunca é mostrado na tela.
 */
export const CHAVE_TOKEN_DISPOSITIVO = 'op:dispositivo'
export { HEADER_DISPOSITIVO }

function armazenamento(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

/**
 * Token salvo no aparelho. Em desenvolvimento, `VITE_DISPOSITIVO_TOKEN`
 * (apps/web/.env.development) aponta para o tablet demo que o seed cria, para
 * o posto abrir direto sem vincular; o build de produção não tem a variável.
 */
export function obterTokenDispositivo(): string | null {
  const salvo = armazenamento()?.getItem(CHAVE_TOKEN_DISPOSITIVO)
  if (salvo) return salvo
  const demo = import.meta.env.VITE_DISPOSITIVO_TOKEN as string | undefined
  return demo ?? null
}

export function salvarTokenDispositivo(token: string) {
  armazenamento()?.setItem(CHAVE_TOKEN_DISPOSITIVO, token)
}

export function limparTokenDispositivo() {
  armazenamento()?.removeItem(CHAVE_TOKEN_DISPOSITIVO)
}

/** A API respondeu "este tablet não está vinculado a este posto". */
export const erroDeDispositivo = (erro: unknown): boolean =>
  (erro as { data?: { code?: string } } | null)?.data?.code === CODIGO_SEM_DISPOSITIVO
